module.exports = __webpack_public_path__ + "static/media/step4.31cfc48a.png";